export const sanitizeXML = (input = "") => {
  let s = input.replace(/\\n/g, "\n");
  s = s.replace(/&(?!(?:amp|lt|gt|apos|quot);)/g, "&amp;");
  return s.trim();
};
export const isWellFormedXML = (xmlString) => {
  try {
    const parser = new DOMParser();
    const dom = parser.parseFromString(xmlString, "application/xml");
    const hasError =
      dom.getElementsByTagName("parsererror").length > 0 ||
      dom.documentElement.nodeName === "parsererror";
    return !hasError;
  } catch {
    return false;
  }
};
export const getRootNameFromXML = (xml) => {
  const noDecl = xml.replace(/^\s*<\?xml[\s\S]*?\?>\s*/i, "");
  const m = noDecl.match(/^<([A-Za-z_][\w\-.:]*)\b/);
  return m ? m[1] : "xml";
};
